import styled from 'styled-components';

const Wrapper = styled.div`
  img {
    display: initial;
  }
  .loader {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    padding-top: 20%; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(255,255,255); /* Fallback color */
    background-color: rgba(255, 255, 255, 0.6); /* Black w/ opacity */
  }

  .loader-img{
    margin-left: auto;
    margin-right: auto;
    display: block;
    padding: 15px;
    background-color: white;
    border-radius: 20px;
    height: 110px;
  }

`;

export default Wrapper;
